export default class GqlErrors {
    constructor(errors = {}) {
        this.errors = errors
    }

    has(field) {
        return Object.keys(this.errors).includes(field)
    }

    clear(field) {
        this.errors = $_.omit(this.errors, field)
    }

    set(errors, refs) {
        $_.each(errors, error => {
            // Lighthouse 6 ne fournit plus `extensions.category` ; on se base sur la
            // présence de `extensions.validation` (compatible Lighthouse 5 et 6).
            const validation = error && error.extensions && error.extensions.validation
            if (validation) {
                $_.each(validation, (messages, key) => {
                    // 'input.description' / 'input.address.zip' -> 'description' / 'zip'
                    const field = key.replace('input.', '').split('.').slice(-1)[0]
                    // Vue 3 : assignation directe (data réactif), `Vue.set` n'existe plus.
                    this.errors[field] = messages
                })
            }
        })

        setTimeout(() => this.errorAnimationForInputs(Object.keys(this.errors), refs))

        return this.errors
    }

    get(field) {
        if ($_.size(this.errors)) {
            if (this.errors[field]) {
                return this.errors[field][0]
            }
        }

        return []
    }

    errorAnimationForInputs(inputs, refs = null) {
        const errorAnimationClasses = ['shake', 'animated']

        if (refs) {
            const inputsKeys = inputs

            if (inputsKeys.includes('password')) {
                inputsKeys.push('password_confirmation')
            }

            inputs = inputsKeys.flatMap(input => {
                const el = refs[input]
                if (el) {
                    return Array.isArray(el) ? $_.first(el) : el
                }

                return []
            })
        }

        $_.castArray(inputs).forEach(input => {
            if (! input) {
                return
            }

            // Composant Vue 3 (a `$el`) -> on cible un <input> interne si présent, sinon la racine.
            if (input.$el) {
                input = input.$el.querySelector('input') || input.$el
            }

            if (! input || ! input.classList) {
                return
            }

            input.classList.add(...errorAnimationClasses)
            input.addEventListener('animationend', () => input.classList.remove(...errorAnimationClasses))
        })
    }
}
